import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Represents the relationship between a leader and an employee. E.g. manager, mentor, delivery lead, etc.',
    name: 'Leader Type',
    partialId: PartialId.Standard.create('leader_type'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
